import { Option } from "~/types/component";
import { Face } from "~/types/question";

export const sex: Option[] = [
  { label: "男性", value: 0 },
  { label: "女性", value: 1 },
  { label: "その他", value: 2 },
];

export const faceType: Option<Face>[] = [
  { label: "楽しい顔", value: "fun" },
  { label: "納得した顔", value: "agree" },
  { label: "困り顔", value: "bothered" },
  { label: "泣き顔", value: "cry" },
  { label: "普通の顔", value: "normal" },
  { label: "照れた顔", value: "shy" },
  { label: "驚いた顔", value: "surprised" },
];
